import React, { memo } from 'react';
import { useI18n } from '../../../../i18n';
import S from './style/ActionKycRetry';

// Aka KYC button
const ActionKycRetry: React.FC<{
  disabled?: boolean;
  onKycRetry?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
}> = function ActionKycRetry({ disabled, onKycRetry }) {
  const i18n = useI18n();

  return (
    <S.ButtonWrapper>
      <S.KYCRetryButton
        data-testid="kyc-retry-button"
        data-cy="kyc-retry-btn"
        disabled={disabled}
        onClick={onKycRetry}
      >
        {i18n`dlv_orders_kyc_retry`}
      </S.KYCRetryButton>
    </S.ButtonWrapper>
  );
};

export default memo(ActionKycRetry);
